module.exports = __webpack_public_path__ + "img/MAC160_1-1.0c85379f.jpg";